import getters from './regions.getters';
import mutations from './regions.mutations';
import actions from './regions.actions';

export const PREFIX = 'regions';

const initialState = () => ({
  selectedFilters: [],
  topics: [],
  selectedTopic: '',
  selectedSubtopic: {},
  data: [],
  yearFilter: null,
  loading: true,
});

export default {
  namespaced: true,
  state: initialState,
  getters,
  mutations,
  actions,
};
